import React, { useState } from 'react'
import MaskedInput from 'react-text-mask'
import { useDispatch } from 'react-redux'

import {
  CircularProgress,
  Dialog,
  DialogContent,
  TextField,
  DialogTitle,
  DialogActions,
  Button
} from '@material-ui/core'

import { useLiterals } from '~/components/Literals'
import api from '~/api'
import actions from '~/actions'
import _values from 'lodash/values'
import track from '~/track'

function validateCnpj(cnpj) {
  const fakes = [
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999'
  ]
  if (cnpj == '') return false

  if (cnpj.length != 14) return false

  // Elimina CNPJs invalidos conhecidos
  if (fakes.includes(cnpj)) return false

  // Valida DVs
  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0, tamanho)
  let digitos = cnpj.substring(tamanho)
  let soma = 0
  let pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) pos = 9
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  if (resultado != digitos.charAt(0)) return false

  tamanho = tamanho + 1
  numeros = cnpj.substring(0, tamanho)
  soma = 0
  pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) pos = 9
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  if (resultado != digitos.charAt(1)) return false

  return true
}

function validate(values, getLiteral) {
  const errors = {}

  if (!values.username) {
    errors.username = getLiteral('2042')
  }

  if (!values.name) {
    errors.name = getLiteral('2043')
  }

  if (!values.email) {
    errors.email = getLiteral('2044')
  } else if (!/^.+@.+\..+$/.test(values.email)) {
    errors.email = getLiteral('1220')
  }

  if (!values.phone) {
    errors.phone = getLiteral('2045')
  }

  if (!values.cnpj.length || (values.cnpj && !validateCnpj(values.cnpj.replace(/[^\d]+/g, '')))) {
    errors.cnpj = getLiteral('2046')
  }

  return errors
}

const cnpjMask = [
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/
]

const phoneMask = [
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /[1-9]/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

const initialState = {
  fields: {
    name: '',
    email: '',
    username: '',
    phone: '',
    cnpj: ''
  },
  errors: {},
  error: false
}

function RetailForm({ open, setRetailOpen, onDone, position }) {
  const [state, setState] = useState(initialState)
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const { getLiteral } = useLiterals()

  const onChange = ({ target: { name, value } }) => {
    setState((state) => ({
      ...state,
      error: false,
      fields: {
        ...state.fields,
        [name]: value
      },
      errors: {
        ...state.errors,
        [name]: false
      }
    }))
  }

  const throwError = (err) => {
    if (!err.field) {
      dispatch(
        actions.snack.add({
          id: Date.now(),
          message: err.message
        })
      )
    }

    if (err.field === 'cnpj') {
      let errors = { cnpj: err.message }
      setState((s) => ({ ...s, errors }))
    }
  }

  const handleCancel = () => {
    if (!loading) {
      track('queroRevenderCancelar', { name: 'cancelar', category: 'menu' })
      setRetailOpen(false) && setState(initialState)
    }
  }

  const hasEmptyFields = () => {
    const { fields: values } = state

    return _values(values).some((field) => !field || !field.length)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    setLoading(true)

    const { fields: values } = state
    const errors = validate(values, getLiteral)
    const hasErrors = Object.keys(errors).length > 0

    track('queroRevenderEnvioForm', { name: values.email, category: 'menu' })

    if (hasErrors) {
      setState((s) => ({ ...s, errors, error: true }))
      setLoading(false)
      return
    }

    try {
      await api.retailMessage({ ...values, location: position.getAddress() })

      dispatch(
        actions.snack.add({
          id: Date.now(),
          message: getLiteral('2186')
        })
      )
      onDone()
    } catch (err) {
      throwError(err)
    } finally {
      setLoading(false)
    }
  }

  const getProps = (field) => {
    const error = state.errors[field]
    return {
      name: field,
      error: !!error,
      helperText: error,
      value: state.fields[field],
      id: field,
      fullWidth: true,
      onChange,
      InputLabelProps: { shrink: true },
      variant: 'outlined',
      style: { marginBottom: 16 }
    }
  }

  return (
    <Dialog open={open} onClose={handleCancel}>
      <DialogTitle>{getLiteral('2047')}</DialogTitle>
      <DialogContent>
        <TextField
          {...getProps('username')}
          label={getLiteral('1067')}
          placeholder={getLiteral('2048')}
          autoFocus
        />
        <TextField
          {...getProps('name')}
          label={getLiteral('1563')}
          placeholder={getLiteral('2049')}
        />
        <MaskedInput
          {...getProps('cnpj')}
          mask={cnpjMask}
          placeholder="00.000.000/0000-00"
          label={getLiteral('2050')}
          render={(ref, props) => <TextField InputProps={{ inputRef: ref }} {...props} />}
        />
        <TextField
          {...getProps('email')}
          label={getLiteral('1136')}
          placeholder={getLiteral('2051')}
          type="email"
        />
        <MaskedInput
          {...getProps('phone')}
          mask={phoneMask}
          label={getLiteral('1032')}
          placeholder="(00) 00000-0000"
          render={(ref, props) => <TextField InputProps={{ inputRef: ref }} {...props} />}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} disabled={loading}>
          {getLiteral('1039')}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading || hasEmptyFields() || state.error}
        >
          {loading ? <CircularProgress size={20} /> : getLiteral('1744')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RetailForm
